import React, { useState } from 'react';
import { Modal, View } from 'react-native';
import { translate } from '../../../services/translate';
import FormActions from '../../../components/FormActions';
import Toast from 'react-native-toast-message';
import { crmService } from '../../../services/central-api/crm';
import { ClientError } from '../../../services/central-api/base-service';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import MyAppText from '../../../components/MyAppText';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DeleteModal from '../../../components/DeleteModal';

interface ModalProps {
    cameraId: string;
    setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
    isModalVisible: boolean;
    onReset: () => void;
}

export default function FactoryResetModal({ cameraId, isModalVisible, setIsModalVisible, onReset }: ModalProps) {
    const { styles, theme } = useStyles(styleSheet);

    const [isConfirmModalVisible, setIsConfirmModalVisible] = useState<boolean>(false);

    async function formSubmit() {
        try {
            await crmService.resetFactory(cameraId);

            Toast.show({
                type: 'sentinelxSuccess',
                text1: translate('ActionSuccessfully'),
            });

            setIsModalVisible(false);

            onReset();
        } catch (err) {
            if (err instanceof ClientError) {
                return Toast.show({
                    type: 'sentinelxError',
                    text1: translate(err.message),
                });
            }

            console.error(err);
            Toast.show({
                type: 'sentinelxError',
                text1: translate('unexpectedError'),
            });
        }
    }

    return (
        <>
            <Modal transparent={true}
                visible={isModalVisible}
                animationType='fade'
                onRequestClose={() => setIsModalVisible(false)}>
                <View style={styles.container}>
                    <View style={styles.formContainer}>
                        <View style={styles.header}>
                            <MyAppText style={{ fontSize: 18, fontWeight: 'bold' }}>{translate('attention')}!</MyAppText>
                            <FontAwesomeIcon icon={faExclamationTriangle as IconDefinition} fontSize={45} color={theme.colors.errors['300']} />
                            <MyAppText>{translate('cameraFactoryReset')}</MyAppText>
                        </View>
                        <FormActions
                            onSubmit={() => setIsConfirmModalVisible(true)}
                            onClose={() => setIsModalVisible(false)}
                            disabled={false} />
                    </View>
                </View>
            </Modal>
            <DeleteModal
                isModalVisible={isConfirmModalVisible}
                setModalVisible={setIsConfirmModalVisible}
                customMessage={translate('thisActionCannotBeUndone')}
                onSubmit={formSubmit}
                customConfirm={translate('confirm')}
            />
        </>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    container: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#31313199',
        flex: 1
    },
    formContainer: {
        width: '25%',
        minHeight: 150,
        backgroundColor: theme.colors.container.background,
        borderRadius: 4,
        padding: 20,
        rowGap: 25,
        justifyContent: 'space-between'
    },
    header: {
        flexDirection: 'column',
        gap: 16,
        justifyContent: 'center',
        alignItems: 'center'
    }
}));
